// Copyright © 2026 Gian Marco Cappelli — SAPIENS (finsapiens.it). Tutti i diritti riservati. Sviluppato su commissione esclusiva. Vietata la riproduzione senza autorizzazione scritta.
import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Line } from 'react-chartjs-2';
import { EducBox, ChartBox, ResultCard, InputRow, EDUC, baseChartOpts, fmt } from './shared';

const SavingsCalc = () => {
  const [obiettivo, setObiettivo] = useState('10000');
  const [mensile, setMensile] = useState('300');
  const [tasso, setTasso] = useState('2');
  const [giaSalvato, setGiaSalvato] = useState('0');

  const O = parseFloat(obiettivo) || 0;
  const m = parseFloat(mensile) || 0;
  const r = parseFloat(tasso) || 0;
  const A = parseFloat(giaSalvato) || 0;
  const rM = r / 100 / 12;
  let mesiNeeded = 0;
  if (m > 0) {
    if (rM === 0) {
      mesiNeeded = Math.max(0, Math.ceil((O - A) / m));
    } else {
      let acc = A;
      while (acc < O && mesiNeeded < 1200) {
        acc = acc * (1 + rM) + m;
        mesiNeeded++;
      }
      if (acc < O) mesiNeeded = Infinity;
    }
  }
  const anni = isFinite(mesiNeeded) ? Math.floor(mesiNeeded / 12) : Infinity;
  const mesiRest = isFinite(mesiNeeded) ? mesiNeeded % 12 : 0;

  const N = isFinite(anni) ? anni + 1 : 21;
  const labels = Array.from({ length: N + 1 }, (_, i) => i % 2 === 0 ? `Anno ${i}` : '');
  const dataAcc = Array.from({ length: N + 1 }, (_, i) => {
    let acc = A;
    for (let mo = 0; mo < i * 12; mo++) acc = acc * (1 + rM) + m;
    return Math.round(acc);
  });
  const dataObiettivo = Array.from({ length: N + 1 }, () => Math.round(O));

  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
      <EducBox text={EDUC.savings} />
      <div className="grid sm:grid-cols-2 gap-4 mb-6">
        <InputRow label="Obiettivo (€)" value={obiettivo} onChange={setObiettivo} prefix="€" />
        <InputRow label="Già risparmiato (€)" value={giaSalvato} onChange={setGiaSalvato} prefix="€" />
        <InputRow label="Risparmio mensile (€)" value={mensile} onChange={setMensile} prefix="€" />
        <InputRow label="Rendimento annuo (%)" value={tasso} onChange={setTasso} suffix="%" />
      </div>
      <div className="grid grid-cols-3 gap-4">
        <ResultCard label="Obiettivo" value={`€${fmt(O)}`} />
        <ResultCard label="Tempo stimato" value={isFinite(anni) ? `${anni > 0 ? `${anni} anni` : ''}${mesiRest > 0 ? ` ${mesiRest} mesi` : ''}` || 'Già raggiunto!' : 'Aumenta il risparmio'} green />
        <ResultCard label="Totale versato" value={isFinite(mesiNeeded) ? `€${fmt(m * mesiNeeded)}` : '—'} />
      </div>
      <ChartBox title="Crescita risparmio verso l'obiettivo" height={420}>
        <Line
          data={{
            labels,
            datasets: [
              { label: 'Risparmio accumulato', data: dataAcc, borderColor: '#3D7A52', backgroundColor: 'rgba(61,122,82,0.1)', fill: true, tension: 0.4, pointRadius: 0 },
              { label: 'Obiettivo', data: dataObiettivo, borderColor: '#C9A84C', borderDash: [6, 3], fill: false, pointRadius: 0 },
            ],
          }}
          options={{ ...baseChartOpts(), plugins: { ...baseChartOpts().plugins, legend: { display: true, labels: { color: '#888780' } } } }}
        />
      </ChartBox>
</motion.div>
  );
};

export default SavingsCalc;
